<template>
  <div class="dialog-reset-account">
    <el-dialog :visible.sync="outerVisible" v-model="dialog" @close="handleClose" :close-on-click-modal="false">
      <div id="waiting" class="center" v-if="loading"></div>
      <div class="popup-header">
        <p class="title">
          {{ $t('reset_account_form.title') }}
        </p>
        <p class="description">
          以下のメールアドレス宛にログイン情報の通知メールを再送します。<br>
          問題がなければ以下のボタンを押して再送してください。
        </p>
      </div>
      <div class="main">
        <label class="label">{{ $t('reset_account_form.mail_address') }}</label><br>
        <span class="content">{{ email }}</span>
      </div>
      <div class="footer">
        <el-button type="primary" @click="send" class="btn btn-edit">{{ $t('reset_account_form.send') }}</el-button><br>
        <el-button @click="handleClose" class="btn btn-back">{{ $t('reset_account_form.back') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  export default {
    props: {
      openFormReset: { type: Boolean, required: true, default: false },
      email: { type: String, required: true, default: '' },
    },
    emits: ['isClosePopupReset', 'resetAccount'],
    data() {
      return {
        outerVisible: false,
        innerVisible: false,
        dialog: '',
        isClose: false,
        loading: false
      };
    },
    methods: {
      handleClose() {
        this.$emit('isClosePopupReset');
      },
      send() {
        this.loading = true;
        document.querySelector(".el-dialog__body").classList.add("disabled");
        this.$emit('resetAccount');
      },
    },
    created() {
      this.outerVisible = this.openFormReset;
    }
  }
</script>

<style lang="scss">
  .dialog-reset-account {
    text-align: center !important;
    .el-dialog {
      --el-dialog-margin-top: 10vh;
      --el-dialog-width: 760px;
      height: 611px;
      .el-dialog__body {
        margin-top: 8%;
      }
    }
    .title {
      font: normal normal normal 17px/37px Kozuka Gothic Pr6N;
      letter-spacing: 1.7px;
      color: #000000;
      font-weight: 700
    }
    .description {
      font: normal normal normal 13px/29px Kozuka Gothic Pr6N;
      letter-spacing: 1.3px;
      color: #000000;
    }
    .main {
      background: #F7F3ED 0% 0% no-repeat padding-box;
      width: 85%;
      margin: 0 auto;
      letter-spacing: 0.75px;
      color: #000000;
      padding: 20px;
      .label {
        font: normal normal normal 15px/21px Alternate Gothic No2 D;
      }
      .content {
        font: normal normal normal 15px/33px Kozuka Gothic Pr6N;
        font-weight: 700
      }
    }
    .footer {
      margin-top: 30px;
      .btn {
        font: normal normal normal 13px/29px Kozuka Gothic Pr6N;
        letter-spacing: 1.3px;
        color: #FFFFFF;
        width: 250px;
        height: 50px;
        border-radius: 25px !important;
      }
      .btn-edit {
        background: #AC3B29 0% 0% no-repeat padding-box;
        --el-button-hover-bg-color: #AC3B29;
        --el-button-hover-border-color: #AC3B29;
        --el-button-border-color: #AC3B29;
      }
      .btn-back {
        background: #969696 0% 0% no-repeat padding-box;
        --el-button-hover-bg-color: #969696;
        --el-button-hover-border-color: #969696;
        --el-button-border-color: #969696;
        margin-top: 10px;
      }
    }
  }
</style>
